"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SensorCustom = void 0;

var react_1 = __importDefault(require("react"));

var ReactiveComponent_1 = __importDefault(require("@appbaseio/reactivesearch/lib/components/basic/ReactiveComponent"));

var hooks_1 = require("../../hooks");

var SensorCustom = function SensorCustom() {
  var reactifySearchContext = (0, hooks_1.useReactifySearchContext)();
  var sensors = reactifySearchContext.options.mode === "collection" ? reactifySearchContext.config.sensors.collection : reactifySearchContext.config.sensors.search;
  return react_1.default.createElement(react_1.default.Fragment, null, sensors.map(function (item, index) {
    return react_1.default.createElement(ReactiveComponent_1.default, {
      key: "SensorCustom_".concat(index),
      componentId: "SensorCustom_".concat(index),
      customQuery: function customQuery() {
        return item;
      }
    });
  }));
};

exports.SensorCustom = SensorCustom;